// extracted by mini-css-extract-plugin
module.exports = {"t1qdyznf":"t1qdyznf"};